export default  {
    methods: {
        label(key) {
            return this.$store.getters['label/get'](key);
        },
    }
}
